module.exports = __webpack_public_path__ + "img/tokens.d7a50177.png";